import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRuler } from '@fortawesome/free-solid-svg-icons';

import './header.css';

export default () => <div className="header">
  <h1><FontAwesomeIcon icon={faRuler} /> Measure It Now</h1>
</div>;
